import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VirtualizationComponent } from '../virtualization/virtualization.component';
var COMPONENT_DIRECTIVES = [
    VirtualizationComponent
];
/**
 * @hidden
 *
 * Represents the [NgModule](https://angular.io/docs/ts/latest/guide/ngmodule.html)
 * definition for the Virtualization component.
 */
var VirtualizationModule = /** @class */ (function () {
    function VirtualizationModule() {
    }
    VirtualizationModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [COMPONENT_DIRECTIVES],
                    exports: [COMPONENT_DIRECTIVES],
                    imports: [CommonModule]
                },] },
    ];
    /** @nocollapse */
    VirtualizationModule.ctorParameters = function () { return []; };
    return VirtualizationModule;
}());
export { VirtualizationModule };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-dateinputs/dist/es/virtualization/virtualization.module.js
// module id = ../../../../@progress/kendo-angular-dateinputs/dist/es/virtualization/virtualization.module.js
// module chunks = vendor